import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import { Settings } from "../configuration/settings";

function NotFound() {
    return (
        <>
            <Helmet>
                <title>Сторінку не знайдено</title>
                <meta name="description" content="Сторінку не знайдено" />
            </Helmet>
            <PageTitle title="Сторінку не знайдено :-(" />
            <div className="w-100 text-center">
                <img className="mw-100" src="/notFound.png" alt={`Фото не знайденої сторінки на ${Settings.shopName}`} />
            </div>
            <div className="text-center">
                <Link
                    className="btn btn-secondary mb-5"
                    to="/"
                    title="Перейти на головну сторінку"
                >
                    Перейти на головну сторінку
                </Link>
            </div>
        </>
    );
}

export default NotFound;